var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoResultsinline = function SvgNoResultsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.111 67.556H16.89a4.4 4.4 0 0 1-4.444-4.444V16.89a4.4 4.4 0 0 1 4.444-4.445h46.22a4.4 4.4 0 0 1 4.445 4.445v46.222c0 2.4-1.956 4.444-4.445 4.444",
    fill: "#08a0dd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.889 13.778c-1.753 0-3.111 1.359-3.111 3.111v46.222c0 1.753 1.358 3.111 3.11 3.111h46.223c1.735 0 3.111-1.43 3.111-3.11V16.888c0-1.752-1.358-3.111-3.11-3.111zm-5.778 3.111a5.734 5.734 0 0 1 5.778-5.778H63.11a5.734 5.734 0 0 1 5.778 5.778v46.222c0 3.12-2.535 5.778-5.778 5.778H16.89a5.734 5.734 0 0 1-5.778-5.778z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.111 26.667c0-.736.597-1.333 1.333-1.333H24.89a1.333 1.333 0 0 1 0 2.667H12.444a1.333 1.333 0 0 1-1.333-1.334m42.667 0c0-.736.597-1.333 1.333-1.333h12.444a1.333 1.333 0 1 1 0 2.667H55.111a1.333 1.333 0 0 1-1.333-1.334",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m37.191 22.734-16.067 27.83c-1.248 2.163.312 4.865 2.81 4.865h32.133c2.498 0 4.058-2.702 2.81-4.866L42.81 22.734c-1.25-2.164-4.37-2.164-5.619 0",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.037 22.067c1.762-3.053 6.165-3.053 7.927 0l16.067 27.829c1.762 3.052-.44 6.866-3.964 6.866H23.933c-3.524 0-5.725-3.814-3.963-6.866zm5.618 1.333c-.736-1.275-2.573-1.275-3.31 0L22.28 51.229c-.736 1.275.183 2.866 1.654 2.866h32.134c1.471 0 2.39-1.591 1.655-2.866z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49.914a.97.97 0 0 1-.974-.973v-1.622c0-.539.435-.973.974-.973s.973.434.973.973v1.622a.97.97 0 0 1-.973.973",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 46.9a.416.416 0 0 0-.418.418v1.622c0 .231.186.417.418.417a.416.416 0 0 0 .417-.417v-1.622A.416.416 0 0 0 40 46.9m-1.53.418c0-.846.684-1.529 1.53-1.529.845 0 1.528.683 1.528 1.529v1.622a1.527 1.527 0 1 1-3.057 0z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43.426a.97.97 0 0 1-.974-.973V32.72a.972.972 0 1 1 1.947 0v9.732a.97.97 0 0 1-.973.973",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 32.304a.416.416 0 0 0-.418.418v9.732c0 .231.186.417.418.417a.416.416 0 0 0 .417-.417v-9.732a.416.416 0 0 0-.417-.418m-1.53.418a1.529 1.529 0 1 1 3.058.001v9.73a1.527 1.527 0 1 1-3.057 0z",
    fill: "#000"
  })));
};

export default SvgNoResultsinline;